import type { AuthAdapter, AuthEventCallbacks, AuthLoginResult, AuthSession } from './auth-adapter';

export interface CaesarsJwtAuthAdapterOptions {
  readonly apiBaseUrl: string;
  readonly fetchImpl?: typeof fetch;
}

export class CaesarsJwtAuthAdapter implements AuthAdapter {
  private readonly apiBaseUrl: string;
  private readonly fetchImpl: typeof fetch;

  public constructor(options: CaesarsJwtAuthAdapterOptions) {
    this.apiBaseUrl = options.apiBaseUrl;
    this.fetchImpl = options.fetchImpl ?? globalThis.fetch.bind(globalThis);
  }

  public async getLoginUrl(): Promise<AuthLoginResult> {
    throw new Error('Caesars auth uses JWT token in URL — no login redirect');
  }

  public async exchangeCode(jwtToken: string): Promise<AuthSession> {
    const response = await this.fetchImpl(`${this.apiBaseUrl}/auth/jwt/validate`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ jwt: jwtToken }),
    });
    if (!response.ok) {
      const body = await response.text().catch(() => '');
      throw new Error(`JWT validation failed: ${response.status} ${body}`);
    }
    return (await response.json()) as AuthSession;
  }

  public async logout(_sessionToken: string): Promise<void> {}

  public registerListeners(_callbacks: AuthEventCallbacks): () => void {
    return () => {};
  }
}
